<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <StatusBar :params="this.$route.query.params" />

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 查詢列 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="(currentPage = 1), getInterviewed()"
    >
      <template v-slot:searchItem>
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、聯絡電話）"
          v-model.trim="searchCondition.Keyword"
        />
        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          :picker-options="{
            disabledDate: $common.disabledDateAfterToday,
          }"
          range-separator="-"
          start-placeholder="面談日期(起)"
          end-placeholder="面談日期(迄)"
          v-model="searchCondition.InterviewDateRange"
        />

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="單位面試主管"
          v-model="searchCondition.InterviewSupervisor"
        >
          <el-option
            v-for="supervisor in userOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="HR 面試人員"
          v-model="searchCondition.InterviewHR"
        >
          <el-option
            v-for="supervisor in userOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          placeholder="應聘者狀態"
          v-model="searchCondition.Status"
        >
          <el-option
            v-for="status in candidateStatusOptions"
            :key="status.key"
            :label="status.value"
            :value="status.value"
          >
          </el-option>
        </el-select>
        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="是否已輸入成績"
          v-model="searchCondition.isWriteScore"
        >
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </template>
    </SearchBar>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>

          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>
          <!-- 內容 -->
          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateTimeFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>面談地點</th>
                <td>{{ props.InterviewPlace }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
            </table>
          </template>
          <!-- button group -->
          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" @click="clickReinvite(props)">
              重新邀約
            </button>
            <button
              type="button"
              @click="openCommonModal({ event: 'singleScore', data: props })"
            >
              輸入成績
            </button>
            <button
              type="button"
              @click="getInterviewRecordHistory(props.MatchId)"
            >
              面談紀錄歷程
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button
          type="button"
          class="action-btn"
          @click="openCommonModal({ event: 'batchScore' })"
        >
          <eva-icon name="color-picker-outline" fill="#FFF" />
          <span>批次輸入成績</span>
        </button>
      </template>
    </ActionBar>

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="personData" />

    <!-- 重新邀約 -->
    <ReinviteMailModal :personData="personData" @updatePerson="updatePerson" />

    <!-- 單次輸入成績、批次輸入成績、面談未到 Modal -->
    <div
      class="modal fade"
      id="commonModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        :class="modalEvent === 'reason' ? null : 'modal-xl'"
      >
        <ValidationObserver
          ref="commonModal"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            @submit.prevent="handleSubmit(saveCommonModal)"
            @reset.prevent="reset"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ modalTitle }}
                </h5>
              </div>
              <div class="modal-body">
                <!-- 單次輸入成績、批次輸入成績 -->
                <template
                  v-if="
                    modalEvent === 'singleScore' || modalEvent === 'batchScore'
                  "
                >
                  <el-table :data="candidateScores" border style="width: 100%">
                    <el-table-column
                      fixed
                      label="姓名"
                      height="250"
                      min-width="20%"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.Name }}/{{
                          scope.row.IsForeigner ? "外籍" : "本籍"
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="score in scoreType[0]"
                      :key="score.Seq"
                      :label="score.Name"
                      height="250"
                      align="center"
                      min-width="40%"
                    >
                      <template slot-scope="scope">
                        <span v-for="item in scope.row.Scores" :key="item.Seq">
                          <input
                            type="number"
                            v-if="
                              item.HasOriginScore && item.Name === score.Name
                            "
                            class="form-control text-center"
                            style="background-color: #dedede"
                            disabled
                            v-model="item.OriginScore"
                          />
                          <template v-if="item.Name === score.Name">
                            <ValidationProvider
                              class="w-100"
                              :name="scope.row.Name + score.Name"
                              :rules="{
                                min_value: item.ScoreLowest,
                                max_value: item.ScoreHighest,
                              }"
                              v-slot="{ errors }"
                            >
                              <input
                                type="text"
                                class="form-control text-center"
                                :style="{
                                  backgroundColor: !item.CanWrite
                                    ? '#dedede'
                                    : '#ffffff',
                                }"
                                :disabled="!item.CanWrite"
                                v-model="item.Score"
                              />
                              <span v-if="errors[0]" class="text-danger">
                                {{ errors[0] }}
                              </span>
                            </ValidationProvider>
                          </template>
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <!-- 面談未到 -->
                <template v-else>
                  <div class="form-group">
                    <ValidationProvider
                      name="原因"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <textarea
                        type="text"
                        rows="5"
                        class="form-control"
                        placeholder="請輸入原因"
                        v-model.trim="declineInterview.reason"
                      />
                      <span v-if="errors[0]" class="text-danger">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </template>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ i18n("Buttons.Save") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 面談紀錄歷程 Modal -->
    <div
      class="modal fade"
      id="interviewRecordHistoryModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <span>面談紀錄歷程</span>
          </div>
          <div class="modal-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="d-flex align-items-start" style="margin-bottom: 10px">
                <ValidationProvider
                  ref="addInterviewSupervisor"
                  class="w-100"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    multiple
                    filterable
                    value-key="Guid"
                    placeholder="請選擇"
                    v-model="InterviewSupervisor"
                  >
                    <el-option
                      v-for="supervisor in supervisorOptions"
                      :key="supervisor.Guid"
                      :label="supervisor.Name"
                      :value="supervisor"
                    >
                    </el-option>
                  </el-select>
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
                <button
                  type="button"
                  class="btn btn-primary"
                  style="margin: 2px 0 0 10px; width: 70px"
                  @click="handleSubmit(addInterviewRecord)"
                >
                  加簽
                </button>
              </div>
            </ValidationObserver>
            <div class="evaluation-person-info">
              <div>
                <label for="">姓名</label>
                <div>{{ recordList.Interviewee }}</div>
              </div>

              <div>
                <label for="">面談日期</label>
                <div
                  v-for="(date, index) in recordList.InterviewDateList"
                  :key="index"
                >
                  {{ $common.dateTimeFormatter(date) }}
                </div>
              </div>
              <div v-for="score in recordList.Scores" :key="score.Seq">
                <label for="">{{ score.Name }}</label>
                <div>{{ score.OriginScore }}/{{ score.Score }}</div>
              </div>

              <span
                style="
                  position: absolute;
                  right: 5px;
                  bottom: 2px;
                  color: #ffffff;
                  z-index: 2;
                  font-size: 0.9em;
                "
              >
                最後更新者：{{ recordList.UpdateUser }}
              </span>
            </div>
            <template
              v-if="
                recordList.InterviewRecords &&
                recordList.InterviewRecords.length > 0
              "
            >
              <div style="display: flex; margin-top: 2px">
                <div class="evaluation-body fixed">
                  <div
                    class="evaluation-name"
                    style="height: 60px; line-height: 50px"
                  >
                    單位面試主管
                  </div>
                  <div
                    v-for="item in recordList.InterviewRecords[0]
                      .InterviewRecordAppraisals"
                    :key="item.Name"
                    class="evaluation-field"
                  >
                    {{ item.Name }}
                  </div>

                  <template v-if="recordList.ResumeType === 'IDL'">
                    <div class="evaluation-field">職等</div>
                  </template>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    面談說明
                  </div>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    個人備註
                  </div>
                  <div class="evaluation-field">面談結果</div>

                  <div class="evaluation-field" style="height: 42px" />
                </div>

                <div style="flex: 1; min-width: 1px">
                  <carousel
                    :key="Math.random()"
                    :items="recordList.InterviewRecords.length"
                    :nav="true"
                    :dots="false"
                  >
                    <div
                      v-for="record in recordList.InterviewRecords"
                      class="evaluation-body"
                      :key="record.InterviewSupervisorId"
                      @dblclick="$common.copyText($event)"
                    >
                      <div class="evaluation-name" style="height: 60px">
                        【{{ record.InterviewTitle }}】<br />
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="
                            record.InterviewSupervisor +
                            ' (' +
                            record.InterviewUserType +
                            ')'
                          "
                          placement="right"
                        >
                          <span>
                            {{ record.InterviewSupervisor }} ({{
                              record.InterviewUserType
                            }})
                          </span>
                        </el-tooltip>
                      </div>

                      <div
                        v-for="item in record.InterviewRecordAppraisals"
                        class="evaluation-field"
                        :key="item.Name"
                      >
                        <template
                          v-if="item.Result !== '-' && item.Result !== '未填寫'"
                        >
                          <el-tooltip
                            v-if="item.Remark"
                            class="item"
                            effect="dark"
                            :content="item.Remark"
                            placement="right"
                          >
                            <span>
                              {{ item.Result }}
                            </span>
                          </el-tooltip>
                          <span v-else>{{ item.Result }}</span>
                        </template>
                        <span v-else>{{ item.Result }}</span>
                      </div>

                      <template v-if="recordList.ResumeType === 'IDL'">
                        <!-- 職等 -->
                        <div class="evaluation-field">
                          {{ record.ExpectedJobLevel }}
                        </div>
                      </template>

                      <!-- 面談說明 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.Remark }}
                        </div>
                      </div>
                      <!-- 個人備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.PersonalRemark }}
                        </div>
                      </div>
                      <!-- 面談結果 -->
                      <div class="evaluation-field">
                        <div>
                          {{ record.InterviewResult }}
                        </div>
                      </div>

                      <div class="evaluation-field" style="height: 42px">
                        <button
                          v-if="record.InterviewResult === '未填寫'"
                          class="btn btn-warning btn-sm"
                          @click="
                            interviewRecordUrge(record.InterviewSupervisorId)
                          "
                        >
                          催辦
                        </button>
                        <div v-else>已填寫面談紀錄</div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              data-toggle="modal"
              data-target="#interviewEvaluationModal"
              class="btn btn-primary"
              @click="getApproveInterview(recordList)"
            >
              完成面談評估
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 面談評估 Modal -->
    <EvaluateInterviewModal
      :Source="'Interviewed'"
      :AdmitOptions="admitOptions"
      :IdlRejectOptions="idlRejectOptions"
      :DlRejectOptions="dlRejectOptions"
      :Person="personData"
      @saveApproveInterview="saveApproveInterview"
    />

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import carousel from "vue-owl-carousel2";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 重新邀約
import ReinviteMailModal from "@/components/back/Modal/ReinviteMail";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談評估
import EvaluateInterviewModal from "@/components/back/Modal/EvaluateInterview";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "Interviewed",

  props: {
    did: { // 需求單號
      type: String,
    }
  },

  components: {
    StatusBar,
    Logo,
    PersonCard,
    CardStyle,
    ActionBar,
    SearchBar,
    ReinviteMailModal,
    ResumeNoteModal,
    IdlResume,
    DlResume,
    carousel,
    EvaluateInterviewModal,
    ProgressRecordModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // modal 事件 (單次輸入成績、批次輸入成績、面談未到)
      modalEvent: "",
      modalTitle: "",

      // 人員圖卡列表
      personList: [],
      // 人員資料
      personData: {},

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      // 面談未到
      declineInterview: {},

      // 功能列
      showActionBar: false, // 預設不顯示
      choosePersonList: [], // 選取之人員列表

      // 主管列表
      supervisorOptions: [],

      userOptions: [],

      // 面談紀錄歷程
      recordList: {},

      // 面談評估 Modal
      admitOptions: [], // 錄取[備註]選項
      idlRejectOptions: [], // idl-不錄取[原因]選項
      dlRejectOptions: [], // dl-不錄取[原因]選項

      // 加簽人員列表
      InterviewSupervisor: [],

      // 查詢列
      showSearchBar: false,
      searchCondition: {},

      candidateStatusOptions: [
        { key: "尚未完成面談紀錄", value: "尚未完成面談紀錄" },
        { key: "尚未完成評估", value: "尚未完成評估" },
      ],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁

      // 批次輸入成績
      scoreType: [], // 成績類型
      candidateScores: [], // 應聘者成績

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,
    };
  },

  methods: {
    // 取得 已面談
    getInterviewed() {
      let candidateStatus;
      candidateStatus =
        this.searchCondition.Status &&
        Object.keys(this.searchCondition.Status).length > 0
          ? String(this.searchCondition.Status)
          : null;

      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.jobManagement
        .getInterviewedPaging(
          {
            ...this.searchCondition,
            interviewDateStart: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[0]
                )
              : null,
            interviewDateEnd: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[1]
                )
              : null,
            ApprovalResult: candidateStatus,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.did
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewed();
    },

    // 取得面談評估
    getApproveInterview(props) {
      this.personData = props;
      this.$store.commit("OpenEvaluateInterviewModal", true);
    },

    // 完成面談評估
    saveApproveInterview(params) {
      this.$store.commit("OpenEvaluateInterviewModal", false);
      this.updateLoading(true);

      this.$api.approveInterview
        .putApproveInterview(params)
        .then((response) => {
          if (response.status === 200) {
            this.personList.forEach((item, index, arr) => {
              if (item.InterviewId === this.recordList.InterviewId) {
                arr.splice(index, 1);
              }
            });
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
          }
          this.updateLoading(false);
        });
    },

    // 取得 面談紀錄歷程(HR)
    getInterviewRecordHistory(MatchId) {
      this.updateLoading(true);

      this.MatchId = MatchId;
      this.InterviewSupervisor = [];
      this.$refs.addInterviewSupervisor.reset();

      this.$api.approveInterview
        .getInterviewRecordForHr(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
            let interviewSupervisorId = response.data.InterviewRecords.map(
              (element) => element.InterviewSupervisorId
            );
            this.supervisorOptions = this.supervisorOptions.filter(
              (element) => interviewSupervisorId.indexOf(element.Guid) === -1
            );
          }
          this.updateLoading(false);
          $("#interviewRecordHistoryModal").modal("show");
        });
    },

    // 加簽 API
    addInterviewRecord() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/AddInterviewRecord`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: vm.InterviewSupervisor.map(
          (element) => element.Guid
        ),
        CreateUser: vm.$cookies.get("userName"),
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.personList.forEach((item, index, arr) => {
              if (item.InterviewId === data.InterviewId) {
                arr[index].InterviewSupervisor = vm.InterviewSupervisor.map(
                  (element) => element.Name
                );
              }
            });

            vm.$notify({
              title: "成功",
              message: "加簽成功",
              type: "success",
              duration: 2500,
            });

            vm.getInterviewRecordHistory(vm.MatchId);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "加簽失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 催辦 API
    interviewRecordUrge(supervisor) {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/InterviewRecordUrge`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: supervisor,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "已寄出催辦信件",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "催辦失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 顯示面談主管 (卡片)
    viewSupervisorList(supervisorOptions) {
      this.$msgbox({
        title: "單位面試主管",
        message: `<h5><strong>${supervisorOptions.join("<br/>")}</strong></h5>`,
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showClose: false,
      });
    },

    // 重新邀約
    clickReinvite(person) {
      this.personData = person;
      this.$store.commit("OpenReinviteMailModal", true);
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.personData = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 更新卡片
    updatePerson() {
      this.currentPage = 1;
      this.getInterviewed();
    },

    // 開啟 common modal
    async openCommonModal({ event, data }) {
      this.updateLoading(true);
      if (event === "singleScore" || event === "batchScore") {
        // 單次輸入成績、批次輸入成績
        this.modalEvent = event;
        this.modalTitle = "輸入成績";
        let person = await this.$api.interview.getScores({
          ManpowerDemandNo: this.did,
          MatchIds:
            event === "singleScore"
              ? [data.MatchId]
              : this.choosePersonList.map((item) => item.MatchId),
        });
        this.scoreType = person.data.map((item) => item.Scores);
        this.candidateScores = person.data;
      } else {
        // 面談未到
        this.modalEvent = "reason";
        this.modalTitle = "面談未到";
        this.declineInterview = {
          matchId: data.MatchId,
          reason: "",
        };
      }
      this.$refs.commonModal.reset();
      this.updateLoading(false);
      $("#commonModal").modal("show");
    },

    // 儲存 common modal
    saveCommonModal() {
      $("#commonModal").modal("hide");
      this.updateLoading(true);
      if (
        this.modalEvent === "singleScore" ||
        this.modalEvent === "batchScore"
      ) {
        // 單次輸入成績、批次輸入成績
        this.$api.interview
          .putScores({
            ManpowerDemandNo: this.did,
            UpdateUserName: this.$cookies.get("userName"),
            Candidates: this.candidateScores.map((item) => {
              return {
                ...item,
                Scores: item.Scores.map((score) => {
                  return {
                    ...score,
                    Score: score.Score === null ? null : Number(score.Score),
                  };
                }),
              };
            }),
          })
          .then((response) => {
            if (response.status === 200) {
              this.$notify({
                title: "成功",
                message: "儲存成功",
                type: "success",
                duration: 2000,
              });
              this.clearSelectCard();
            }
            this.updateLoading(false);
          });
      } else {
        // 面談未到
        const data = {
          matchId: this.declineInterview.matchId,
          reason: this.declineInterview.reason,
        };
        this.$api.jobManagement.interviewNotArrived(data).then((response) => {
          if (response.status === 200) {
            this.personList.forEach((item, index, arr) => {
              if (item.MatchId === data.matchId) {
                arr.splice(index, 1);
              }
            });
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2000,
            });
            this.$store.dispatch("GetJobManagementCount");
          }
          this.updateLoading(false);
        });
      }
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.MatchId === choosePerson[0].MatchId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 全選人員
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除所選取人員
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    async getData() {
      // 取得錄取的[備註]下拉選單
      const admit = await this.$api.recruitment.getInterviewBasicCondition();
      // 取得idl不錄取的[原因]下拉選單
      const idl = await this.$api.recruitment.getInterviewNotAdmitReason({
        ResumeType: "IDL",
        IsNotAdmitReason: true,
      });
      // 取得dl不錄取的[原因]下拉選單
      const dl = await this.$api.recruitment.getInterviewNotAdmitReason({
        ResumeType: "DL",
        IsNotAdmitReason: true,
      });
      this.admitOptions = admit.data;
      this.idlRejectOptions = idl.data;
      this.dlRejectOptions = dl.data;

      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();

      // 取得主管列表
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
          Email: user.Email,
        };
      });
      this.userOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
        };
      });
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 選取人員列表
    choosePersonList: function (e) {
      if (e.length > 0) {
        this.showActionBar = true;
        this.showSearchBar = false;
      } else {
        this.showActionBar = false;
      }
    },
    // 檢視資訊
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getData();
    this.getInterviewed();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
#interviewRecordHistoryModal .evaluation-body .evaluation-field {
  height: 35px;
}

/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}

/deep/ .el-table {
  tr {
    th {
      background-color: #303c50 !important;
    }
  }
  .footer-pagination-row {
    .page-item {
      .page-link {
        color: #303c50;
      }

      &.active {
        .page-link {
          background-color: #303c50;
        }
      }
    }
  }
}

/deep/ .el-table__fixed::before {
  height: 0;
}
</style>
